import { PaletteColor } from '@mui/material';
import { getAppTheme } from '../AppTheme';

export const getColorMap = () => {
  const appTheme = getAppTheme();

  return new Map<string, PaletteColor>([
    ['peak-low', appTheme.palette.charts.greenChart],
    ['peak-regular', appTheme.palette.charts.blueChart],
    ['peak-high', appTheme.palette.charts.redChart],
    ['None', appTheme.palette.charts.clearChart],
    ['demand-onPeakDemand', appTheme.palette.charts.greenChart],
    ['demand-customerDemand', appTheme.palette.charts.blueChart],
    ['midpeak-first', appTheme.palette.charts.blueChart],
    ['midpeak-next', appTheme.palette.charts.blueChart],
    ['midpeak-last', appTheme.palette.charts.blueChart],
    ['onpeak-first', appTheme.palette.charts.redChart],
    ['onpeak-next', appTheme.palette.charts.redChart],
    ['onpeak-last', appTheme.palette.charts.redChart],
    ['offpeak-first', appTheme.palette.charts.greenChart],
    ['offpeak-next', appTheme.palette.charts.greenChart],
    ['offpeak-last', appTheme.palette.charts.greenChart],
    ['summer-offpeak', appTheme.palette.charts.greenChart],
    ['summer-onpeak', appTheme.palette.charts.redChart],
    ['winter-offpeak', appTheme.palette.charts.greenChart],
    ['winter-onpeak', appTheme.palette.charts.redChart],
    ['low', appTheme.palette.charts.greenChart],
    ['regular', appTheme.palette.charts.blueChart],
    ['high', appTheme.palette.charts.yellowChart],
  ]);
};
